import { useState } from 'react';
import { Dropdown, DropdownButton, Form, Button } from 'react-bootstrap';
import '../styles/create_building.css';

function CreateBuilding() {
    const [location, setLocation] = useState("Pilih lokasi");
    const [faculty, setFaculty] = useState('');
    const [name, setName] = useState('');

    const handleSelect = (e) => {
        console.log(e);
        setLocation(e);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        // TODO call submit create building api
    }

    return (
        <div className="create_building">
            <h2>Tambah Gedung</h2>

            <DropdownButton
                id="dropdown-basic-button"
                title={location}
                onSelect={handleSelect}
            >
                <Dropdown.Item eventKey="Kampus Ganesha">Kampus Ganesha</Dropdown.Item>
                <Dropdown.Item eventKey="Kampus Jatinangor">Kampus Jatinangor</Dropdown.Item>
            </DropdownButton>

            <Form>
                <Form.Label>Nama gedung</Form.Label>
                <Form.Group controlId="buildingName">
                    <Form.Control
                        type="text"
                        placeholder="Masukkan nama gedung..."
                        value={name}
                        onChange={e => setName(e.target.value)}
                    />
                </Form.Group>

                <Form.Label>Fakultas gedung</Form.Label>
                <Form.Group controlId="buildingFaculty">
                    <Form.Control
                        type="text"
                        placeholder="Masukkan fakultas gedung..."
                        value={faculty}
                        onChange={e => setFaculty(e.target.value)}
                    />
                </Form.Group>

                <Button 
                    variant="primary"
                    type="submit"
                    onClick={handleSubmit}
                >
                    Submit
                </Button>
            </Form>
        </div>
    );
}

export default CreateBuilding;
